<app-reports
  title="Enhanced Claims Match Reports"
  [reportsUrl]="reportsUrl" />
